function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.9871 6.641C17.9871 10.309 15.0131 13.283 11.3461 13.283C7.6781 13.283 4.7041 10.309 4.7041 6.641C4.7041 2.974 7.6781 0 11.3461 0C15.0131 0 17.9871 2.974 17.9871 6.641Z",
  fill: "#FEFEFE"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 15,
  width: 24,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 15.7725H23.244V30.8935H0V15.7725Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.244 30.8935V22.6275C23.244 20.0705 21.569 17.8155 19.121 17.0765L14.807 15.7725C13.336 18.1265 9.90802 18.1265 8.43602 15.7725L4.12202 17.0765C1.67402 17.8155 -0.000976562 20.0705 -0.000976562 22.6275V30.8935H23.244Z",
  fill: "#FEFEFE"
}));

var SvgPersonIcon = function SvgPersonIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person-icon.270b6a98.svg";
export { ForwardRef as ReactComponent };